import {SetVariantFunc} from "./utils.variants";
import {GameVariant, Nullable} from "./caos-def";
import {initNavigation} from "./navigation";

export default function init(
    $doc: Document,
    getVariant: () => Nullable<GameVariant>,
    setVariant: SetVariantFunc,
    setSeaMonkeys: (enable: Nullable<boolean>) => void,
): void {
    initNavigation(getVariant, setVariant, setSeaMonkeys);
}